import React, { useState, useEffect } from "react";
import { useEthers } from "@usedapp/core";
import { ethers } from "ethers";
import {
  FormContainer,
  FormTitle,
  Form,
  Input,
  CurrentPriceContainer,
  CurrentPriceLabel,
  CurrentPriceValue,
  MaxButton,
  InputGroup,
  AmountInput,
  PositionCard,
} from "./styles";
import { Contract } from "@ethersproject/contracts";
import { addresses, abis } from "@my-app/contracts";

import AllowanceChecker from "./AllowanceChecker";

const isAddress = (address) => {
  try {
    return ethers.utils.isAddress(address);
  } catch {
    return false;
  }
};

const ethereumAddressPattern = "^0x[a-fA-F0-9]{40}$";

// Component
const LimitOrderForm = () => {
  const { library, account } = useEthers();

  const [tokenIn, setTokenIn] = useState("");
  const [tokenOut, setTokenOut] = useState("");
  const [desiredPrice, setDesiredPrice] = useState(0);
  const [amount, setAmount] = useState("");
  const [currentPrice, setCurrentPrice] = useState(null); // Added currentPrice state
  const [contract, setContract] = useState(null);
  const [balance, setBalance] = useState(""); // State to store the user's balance

  const addPosition = async () => {
    console.log("Adding position");

    const decimals = await new Contract(
      tokenOut,
      abis.erc20,
      library.getSigner()
    ).decimals();

    const decimals1 = await new Contract(
      tokenIn,
      abis.erc20,
      library.getSigner()
    ).decimals();

    const desiredPriceBN = ethers.utils.parseUnits(
      desiredPrice.toString(), // Convert the floating-point number back to a string
      decimals
    );

    const amountBN = ethers.utils.parseUnits(
      amount.toString(), // Convert the floating-point number back to a string
      decimals1
    );

    console.log("Desired price:", desiredPriceBN.toString());
    console.log("Amount:", amountBN.toString());

    try {
      const txResponse = await contract.addPosition([
        tokenIn,
        tokenOut,
        amountBN,
        desiredPriceBN,
        account,
      ]);
      console.log("Transaction hash:", txResponse.hash);
    } catch (error) {
      console.error("Failed to add position", error);
    }
  };

  // Handle direct desired price input
  const handleDesiredPriceInput = (e) => {
    const value = parseFloat(e.target.value);
    setDesiredPrice(value);
  };

  useEffect(() => {
    if (currentPrice) {
      setDesiredPrice(currentPrice);
    }
  }, [currentPrice]);

  useEffect(() => {
    if (library && account) {
      const signer = library.getSigner();
      const contractInstance = new Contract(
        addresses.positionManager,
        abis.positionManager,
        signer
      );
      setContract(contractInstance);
    }
  }, [library, account]);

  useEffect(() => {
    const fetchCurrentPrice = async () => {
      if (tokenIn && tokenOut && contract) {
        if (!isAddress(tokenIn) || !isAddress(tokenOut)) {
          console.error("Invalid token address");
          return;
        }
        try {
          const price = await contract.getPrice(tokenIn, tokenOut);
          const contractTokenOut = new Contract(
            tokenOut,
            abis.erc20,
            library.getSigner()
          );
          // const contractTokenIn = new Contract(
          //   tokenIn,
          //   abis.erc20,
          //   library.getSigner()
          // );

          // const name0 = await contractTokenIn.symbol();
          // const name1 = await contractTokenOut.symbol();

          const decimals = await contractTokenOut.decimals();

          const assetPrice = parseFloat(
            ethers.utils.formatUnits(price, decimals)
          );
          setCurrentPrice(assetPrice);
          setDesiredPrice(assetPrice);
        } catch (error) {
          console.error("Failed to fetch current price", error);
          setCurrentPrice(null); // Reset current price on error
        }
        const contractTokenIn = new Contract(
          tokenIn,
          abis.erc20,
          library.getSigner()
        );
        contractTokenIn
          .balanceOf(account)
          .then((balance) => {
            const formattedBalance = ethers.utils.formatUnits(balance, "ether"); // Replace 'ether' with the correct number of decimals
            setBalance(formattedBalance);
          })
          .catch((error) => {
            console.error("Failed to fetch balance", error);
          });
      }
    };

    fetchCurrentPrice();
  }, [tokenIn, tokenOut, contract, library, account]); // Depend on these values to re-fetch when they change

  const handleMaxClick = (e) => {
    e.preventDefault();
    setAmount(balance); // Set the amount to the maximum balance available
  };

  return (
    <FormContainer>
      <PositionCard>
        <FormTitle>Add Order</FormTitle>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Input
            type="text"
            placeholder="Token In"
            value={tokenIn}
            pattern={ethereumAddressPattern}
            onChange={(e) => setTokenIn(e.target.value)}
            title="Must be a valid Ethereum address."
            required
          />
          <Input
            type="text"
            placeholder="Token Out"
            value={tokenOut}
            pattern={ethereumAddressPattern}
            onChange={(e) => setTokenOut(e.target.value)}
            title="Must be a valid Ethereum address."
            required
          />
          <CurrentPriceContainer>
            <CurrentPriceLabel>Current Price:</CurrentPriceLabel>
            <CurrentPriceValue>{currentPrice}</CurrentPriceValue>
          </CurrentPriceContainer>
          <Input
            type="number"
            placeholder="Desired Price"
            value={desiredPrice}
            onChange={handleDesiredPriceInput}
            required
          />
          <InputGroup>
            <AmountInput
              type="number"
              placeholder="Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              required
            />
            <MaxButton onClick={handleMaxClick}>Max</MaxButton>
          </InputGroup>

          {/* <SubmitButton type="submit">Add</SubmitButton> */}
          <AllowanceChecker
            tokenIn={tokenIn}
            amount={amount}
            onApproval={addPosition}
          />
        </Form>
      </PositionCard>
    </FormContainer>
  );
};

export default LimitOrderForm;

// 0x6fea480075e4ba76c8fa6ed8cc9b8b2de5305b88 BOOK
// 0xeb54dacb4c2ccb64f8074eceea33b5ebb38e5387 WDEGEN
